import { Text } from '@northladder/i18n';

import { CheckCircleIcon } from '@heroicons/react/24/outline';

import { IDeviceImageOptionsWithMetadataTranslations } from '../types';
import { apiTranslations } from '../../translations';

type TIntermediateDoneUploadingProps = Pick<
  IDeviceImageOptionsWithMetadataTranslations,
  'title' | 'titlePostfix'
>;

/**
 * -----------------------------------------------------------------------------
 * Displays that the image has already been uploaded.
 * It will show only the upload status is `COMPLETED`
 */
export function IntermediateDoneUploading({
  // subTitle,
  title,
  titlePostfix,
}: TIntermediateDoneUploadingProps) {
  return (
    <div
      className="
        space-between xsm:flex-1 xsm:w-1/2 group relative flex w-full
        flex-col items-center rounded-lg border border-green-50 bg-green-600/20
        bg-white py-4 text-center transition-all duration-300 ease-in
      "
    >
      <div className="flex flex-1 flex-col justify-center p-12">
        <CheckCircleIcon
          className="fill-green-600x mx-auto h-12 w-12
              self-center stroke-green-900 stroke-1
              group-hover:stroke-green-300 group-focus:stroke-green-400"
        />
        <span
          className="mt-2 block text-sm text-green-900
             group-hover:text-green-500 group-focus:text-green-400"
        >
          <Text text={apiTranslations.uploadDone.uploadDoneTitle} />
        </span>
      </div>
      <div
        className="
          w-full flex-col px-4 py-2 text-sm
          group-hover:text-green-500 group-focus:text-green-400
        "
      >
        <p
          className="
            flex w-full flex-col items-start pb-1 pt-2 text-sm text-green-900
            group-hover:text-green-500 group-focus:text-green-400
          "
        >
          {title ? (
            <span>
              <Text text={title} />
            </span>
          ) : null}

          {titlePostfix ? (
            <span className="text-xs font-light">
              <Text text={titlePostfix} />
            </span>
          ) : null}
        </p>

        {/* <span
          className="
              flex  w-full flex-col text-start text-xs font-light
              text-gray-400 group-hover:text-primary-500 group-focus:text-primary-400
            "
        >
          {subTitle ? (
            <span className="py-1">
              <Text text={subTitle} />
            </span>
          ) : null}
        </span> */}
      </div>
    </div>
  );
}
